var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete2New(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.878,
    height: 14.635,
    viewBox: "0 0 11.878 14.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9319",
    "data-name": "Rectangle 9319",
    width: 11.877,
    height: 14.634,
    fill: "#0f0f0f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10912",
    "data-name": "Group 10912",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20974",
    "data-name": "Path 20974",
    d: "M9.394,14.634H2.484a2.05,2.05,0,0,1-.768-.318,1.856,1.856,0,0,1-.746-1.574q0-4.112,0-8.224a.187.187,0,0,0-.144-.212,1.307,1.307,0,0,1,.546-2.52c.509-.006,1.018,0,1.527,0,.05,0,.1,0,.156-.007,0-.141,0-.264,0-.388A1.332,1.332,0,0,1,4.383.013C5.42-.008,6.457,0,7.493.011A1.323,1.323,0,0,1,8.8,1.268c.007.169,0,.338,0,.517h1.688a1.35,1.35,0,0,1,1.064.459,1.5,1.5,0,0,1,.325.762v.2a.915.915,0,0,0-.027.095,1.255,1.255,0,0,1-.811,1,.191.191,0,0,0-.14.217q0,4.063,0,8.127a3.916,3.916,0,0,1-.025.441A1.76,1.76,0,0,1,9.527,14.6c-.045.01-.089.025-.133.037M1.656,4.4v.127q0,4.106,0,8.213a1.858,1.858,0,0,0,.022.284,1.049,1.049,0,0,0,1.047.924q3.212,0,6.423,0a.987.987,0,0,0,.7-.273,1.254,1.254,0,0,0,.366-.971q0-4.078,0-8.156V4.4Zm4.272-.694h4.495a2,2,0,0,0,.214-.01.611.611,0,0,0,.112-1.189,1.161,1.161,0,0,0-.31-.034q-4.5,0-9,0a1.5,1.5,0,0,0-.227.015.609.609,0,0,0-.514.567.6.6,0,0,0,.417.613,1.139,1.139,0,0,0,.323.038q2.247,0,4.495,0M8.123,1.777c0-.159.011-.311,0-.46A.65.65,0,0,0,7.438.692c-.276,0-.552,0-.828,0-.723,0-1.446,0-2.17,0a.633.633,0,0,0-.659.464,4.243,4.243,0,0,0-.051.621Z",
    transform: "translate(0 0)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20975",
    "data-name": "Path 20975",
    d: "M125.492,189.218q0,1.549,0,3.1c0,.048,0,.1,0,.143a.341.341,0,0,1-.317.328.336.336,0,0,1-.352-.286.793.793,0,0,1-.013-.156q0-3.133,0-6.267c0-.292.134-.452.365-.439a.333.333,0,0,1,.318.339c.007.128,0,.257,0,.385q0,1.427,0,2.855",
    transform: "translate(-121.236 -180.326)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20976",
    "data-name": "Path 20976",
    d: "M195.476,189.212q0-1.577,0-3.155c0-.253.115-.4.318-.412a.32.32,0,0,1,.346.254.878.878,0,0,1,.02.2q0,3.119,0,6.238a.894.894,0,0,1-.023.211.331.331,0,0,1-.636.017.766.766,0,0,1-.024-.211q0-1.57,0-3.14",
    transform: "translate(-189.882 -180.332)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20977",
    "data-name": "Path 20977",
    d: "M266.083,189.175q0-1.563,0-3.126c0-.3.114-.451.334-.455s.351.159.351.456q0,3.119,0,6.238c0,.3-.129.463-.352.457s-.333-.161-.333-.458q0-1.556,0-3.112",
    transform: "translate(-258.468 -180.282)",
    fill: "#0f0f0f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2New);
export default __webpack_public_path__ + "static/media/Delete 2 New.640611305f7ea2424e34955ffd78b5df.svg";
export { ForwardRef as ReactComponent };